import { Link } from 'react-router-dom';

export function BreadCrumbs({ items }: any) {
    if (!items || !items.length) {
        return <></>;
    }
    return (
        <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold my-2 p-0">
            <Link className="breadcrumb-item" to="/">
                Dashboard
            </Link>
            {items.map((item: any, index: number) => (
                <li className="breadcrumb-item" key={index}>
                    <Link className="text-muted " to={{ pathname: item.pathname }}>
                        {item.title}
                    </Link>
                </li>
            ))}
        </ul>
    );
}
